import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Result } from '../../../core/models/projects.interface';
import { LanguageService } from '../../../core/services/Language/lang.service';

const STATUS_TRANSLATIONS: Record<string, { ar: string; en: string }> = {
  open: { ar: 'متاح للتعاقد', en: 'Open for Contract' },
  funded: { ar: 'مكتمل التمويل', en: 'Fully Funded' },
  active: { ar: 'نشط', en: 'Active' },
  pending: { ar: 'قيد الانتظار', en: 'Pending' },
  completed: { ar: 'مكتمل', en: 'Completed' },
  harvest: { ar: 'حصاد', en: 'Harvest' },
  sale: { ar: 'بيع', en: 'Sale' },
};

@Component({
  selector: 'app-project-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './project-card.component.html',
})
export class ProjectCardComponent {
  public readonly languageService = inject(LanguageService);

  @Input() project!: Result;
  @Input() buttonLabelKey = 'contract_now';

  @Output() investClick = new EventEmitter<Result>();

  t(key: string): string {
    const lang = this.languageService.getLang();

    const dict: Record<string, { ar: string; en: string }> = {
      expected_return: { ar: 'العائد المتوقع', en: 'Expected Return' },
      duration: { ar: 'المدة', en: 'Duration' },
      min_contract: { ar: 'الحد الأدنى للتعاقد', en: 'Minimum Contract' },
      contract_now: { ar: 'تعاقد الآن', en: 'Contract Now' },
      share_price: { ar: 'سعر الفاتورة', en: 'Invoice Price' },
      return: { ar: 'الدفعات', en: 'Returns' },
      month: { ar: 'شهر', en: 'Month' },

    };

    return dict[key]?.[lang] || key;
  }

  get currencyLabel(): string {
    return this.languageService.getLang() === 'ar' ? 'ج.م.' : 'EGP';
  }

  getStatusLabel(status: string): string {
    const lang = this.languageService.getLang();
    return STATUS_TRANSLATIONS[status?.toLowerCase()]?.[lang] || status;
  }

  get isInvestDisabled(): boolean {
    const status = this.project?.status?.toLowerCase();
    return status !== 'open';
  }

  onButtonClick(): void {
    if (this.isInvestDisabled) return;
    this.investClick.emit(this.project);
  }
}